var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.link}},[_c('img',{staticClass:"arrow",style:({width: _vm.width +'px'}),attrs:{"src":require("@/assets/voet.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }